{
  "base": "vs",
  "inherit": true,
  "rules": [
    {
      "token": "comment",
      "foreground": "A0A0A0",
      "fontStyle": " italic"
    },
    {
      "token": "string",
      "foreground": "096545"
    },
    {
      "token": "constant.numeric",
      "foreground": "6554C0"
    },
    {
      "token": "number",
      "foreground": "6554C0"
    },
    {
      "token": "constant.language",
      "foreground": "6554C0"
    },
    {
      "token": "constant.character,",
      "foreground": "6554C0"
    },
    {
      "token": "constant.other",
      "foreground": "6554C0"
    },
    {
      "token": "variable",
      "foreground": "0059DF"
    },
    {
      "token": "keyword",
      "foreground": "091E42",
      "fontStyle": " bold"
    },
    {
      "token": "storage",
      "foreground": "BF2600",
      "fontStyle": " bold"
    },
    {
      "token": "storage.type",
      "foreground": "0049B0",
      "fontStyle": " bold"
    },
    {
      "token": "entity.name.class,",
      "foreground": "A62400",
      "fontStyle": " bold"
    },
    {
      "token": "entity.name.type.class",
      "foreground": "A62400",
      "fontStyle": " bold"
    },
    {
      "token": "entity.other.inherited-class",
      "foreground": "007488"
    },
    {
      "token": "meta.function.decorator,",
      "foreground": "0059DF",
      "fontStyle": ""
    },
    {
      "token": "entity.name.function.decorator,",
      "foreground": "0059DF",
      "fontStyle": ""
    },
    {
      "token": "storage.type.annotation",
      "foreground": "0059DF",
      "fontStyle": ""
    },
    {
      "token": "entity.name.function",
      "foreground": "BF2600",
      "fontStyle": " bold"
    },
    {
      "token": "variable.parameter,",
      "foreground": "091E42"
    },
    {
      "token": "meta.function-call.arguments",
      "foreground": "091E42"
    },
    {
      "token": "entity.name.tag",
      "foreground": "0052CC",
      "fontStyle": " bold"
    },
    {
      "token": "entity.other.attribute-name",
      "foreground": "0059DF",
      "fontStyle": ""
    },
    {
      "token": "support.function",
      "foreground": "007488",
      "fontStyle": ""
    },
    {
      "token": "support.constant",
      "foreground": "007488",
      "fontStyle": ""
    },
    {
      "token": "support.type,",
      "foreground": "D32F2F",
      "fontStyle": " bold"
    },
    {
      "token": "support.class",
      "foreground": "D32F2F",
      "fontStyle": " bold"
    },
    {
      "token": "support.other.variable"
    },
    {
      "token": "support",
      "foreground": "6554C0"
    },
    {
      "token": "invalid",
      "background": "FF5630",
      "foreground": "F8F8F0",
      "fontStyle": ""
    },
    {
      "token": "invalid.deprecated",
      "background": "FFBDAD",
      "foreground": "F8F8F0"
    },
    {
      "token": "text.html.markdown",
      "foreground": "6554C0"
    },
    {
      "token": "markup.raw.inline",
      "foreground": "6554C0"
    },
    {
      "token": "text.html.markdown",
      "foreground": "D32F2F"
    },
    {
      "token": "meta.dummy.line-break",
      "foreground": "D32F2F"
    },
    {
      "token": "markdown.heading,",
      "foreground": "096545",
      "fontStyle": "bold"
    },
    {
      "token": "markup.heading,",
      "foreground": "096545",
      "fontStyle": "bold"
    },
    {
      "token": "markup.heading",
      "foreground": "096545",
      "fontStyle": "bold"
    },
    {
      "token": "entity.name,",
      "foreground": "096545",
      "fontStyle": "bold"
    },
    {
      "token": "markup.heading.markdown,",
      "foreground": "096545",
      "fontStyle": "bold"
    },
    {
      "token": "punctuation.definition.heading.markdown",
      "foreground": "096545",
      "fontStyle": "bold"
    },
    {
      "token": "markup.italic",
      "foreground": "D32F2F",
      "fontStyle": "italic"
    },
    {
      "token": "markup.bold",
      "foreground": "D32F2F",
      "fontStyle": "bold"
    },
    {
      "token": "markup.underline",
      "foreground": "D32F2F",
      "fontStyle": "underline"
    },
    {
      "token": "markup.quote,",
      "foreground": "9F5700",
      "fontStyle": "italic"
    },
    {
      "token": "punctuation.definition.blockquote.markdown",
      "foreground": "9F5700",
      "fontStyle": "italic"
    },
    {
      "token": "markup.quote",
      "foreground": "9F5700",
      "fontStyle": "italic"
    },
    {
      "token": "string.other.link.title.markdown",
      "foreground": "ABF5D1",
      "fontStyle": "underline"
    },
    {
      "token": "markup.raw.block",
      "foreground": "006644"
    },
    {
      "token": "punctuation.definition.fenced.markdown,",
      "foreground": "006644"
    },
    {
      "token": "variable.language.fenced.markdown,",
      "foreground": "006644"
    },
    {
      "token": "markup.raw.block.fenced.markdown",
      "foreground": "006644"
    },
    {
      "token": "variable.language.fenced.markdown",
      "foreground": "36B37E",
      "fontStyle": ""
    },
    {
      "token": "punctuation.definition.list_item.markdown,",
      "foreground": "0059DF"
    },
    {
      "token": "meta.paragraph.list.markdown",
      "foreground": "0059DF"
    },
    {
      "token": "meta.separator",
      "background": "36B37E",
      "foreground": "0059DF",
      "fontStyle": "bold"
    },
    {
      "token": "markup.table",
      "foreground": "FFAB00"
    },
    {
      "token": "meta.diff,",
      "foreground": "616161",
      "fontStyle": "italic"
    },
    {
      "token": "meta.diff.header",
      "foreground": "616161",
      "fontStyle": "italic"
    },
    {
      "token": "markup.deleted",
      "background": "FFEBE6"
    },
    {
      "token": "markup.inserted",
      "background": "E4FDEF"
    },
    {
      "token": "markup.changed",
      "background": "FFBDAD"
    },
    {
      "token": "meta.diff,",
      "foreground": "1397f1"
    },
    {
      "token": "meta.diff.range",
      "foreground": "1397f1"
    },
    {
      "token": "sublimelinter.gutter-mark",
      "foreground": "FFFFFF"
    },
    {
      "token": "sublimelinter.mark.error",
      "foreground": "D32F2F"
    },
    {
      "token": "sublimelinter.mark.warning",
      "foreground": "FFAB00"
    },
    {
      "token": "comment.block.attribute.rust",
      "foreground": "FFAB00"
    },
    {
      "token": "meta.preprocessor.rust",
      "foreground": "9F5700"
    },
    {
      "token": "meta.namespace-block.rust",
      "foreground": "FFBDAD"
    },
    {
      "token": "support.type.property-name.json",
      "foreground": "0052CC",
      "fontStyle": " bold"
    },
    {
      "token": "string.quoted.double.json",
      "foreground": "091E42",
      "fontStyle": ""
    },
    {
      "token": "support.class.component.js.jsx",
      "foreground": "0052CC",
      "fontStyle": " bold"
    },
    {
      "token": "identifier",
      "foreground": "202020"
    }
  ],
  "colors": {
    "editor.background": "#FFFFFF",
    "editor.foreground": "#091E42",
    "editor.lineHighlightBackground": "#DFE1E5",
    "editorCursor.foreground": "#091E42",
    "selection.background": "#DFE1E5",
    "editorIndentGuide.background": "#DFE1E5"
  }
}
